import { Fab, makeStyles, Tooltip, Zoom } from '@material-ui/core'
import { ExpandLess } from '@material-ui/icons'
import classnames from 'classnames'
import React, { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'

type ScrollToTopProps = {
  // firstProp: firstPropType
}

const useStyles = makeStyles((theme) => ({
  viewPort: {
    height: '100vh',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  tooltip: {
    fontFamily: theme.typography.h1.fontFamily,
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    '&.intercomOffset': {
      right: `calc(87px + ${theme.spacing(2)}px)`,
      bottom: 23,
    },
  },
}))

const ScrollToTop: React.FC<ScrollToTopProps> = () => {
  const classes = useStyles()
  const { ref, inView } = useInView()
  const [intercomOffset, setIntercomOffset] = useState(false)

  useEffect(() => {
    if (inView) {
      const intercomOffset =
        typeof document !== 'undefined' &&
        !!document.getElementsByClassName('intercom-launcher').length
      setIntercomOffset(intercomOffset)
    }
  }, [inView])

  function handleScrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <>
      <div className={classes.viewPort} ref={ref} />
      <Zoom in={!inView} unmountOnExit>
        <Tooltip arrow title="Scroll to top" placement="left">
          <Fab
            className={classnames(classes.fab, { intercomOffset })}
            onClick={handleScrollToTop}
          >
            <ExpandLess />
          </Fab>
        </Tooltip>
      </Zoom>
    </>
  )
}

export default ScrollToTop
